.ux-table-sort {
  cursor: pointer;
  white-space: nowrap;

  &[sorted-direction="asc"] {
    border-bottom: solid 1px;

    .ux-icon__sort-down {
      fill: $color-green;
    }
  }

  &[sorted-direction="desc"] {
    border-bottom: solid 1px;

    .ux-icon__sort-up {
      fill: $color-green;
    }
  }

  &__icon {
    fill: currentcolor;
    font-size: 12px;
    margin-left: 7px;
    padding-bottom: 2px;
  }
}
